import { ForwardedRef, forwardRef, useImperativeHandle, useState } from 'react'
// Material
import { Badge } from '@mui/material'
import { styled } from '@mui/material/styles'
// Common
import { UserAvatar } from '$common/avatar'
import { WithEditableAvatar } from '$common/with-editable-avatar'
// Icons
import { showProfilePictureMenu } from '$comp/modals/menus/profile-picture-menu'
import { getClientUser } from '$logic/client-user'
import { AvatarSize } from '$common/avatar/avatar-base/types'

const StyledBox = styled(Badge)(() => ({
  position: 'absolute',
  top: -50,
  left: 'calc(50% - 50px)',
  display: 'flex',
  marginRight: -20,
}))

const StyledUserAvatar = styled(UserAvatar)`
  border: 5px solid white;
  // TODO: Pick random bgcolor
  background-color: #455a64;
  cursor: pointer;
`

export interface EditAccountProfileBoxApiType {
  get: () => string
}

export const EditAccountProfileBox = forwardRef(
  function EditAccountProfileBoxComponent(
    _,
    ref: ForwardedRef<EditAccountProfileBoxApiType>,
  ) {
    const clientUser = getClientUser()
    const [imageFileId, setImageFileId] = useState<string | undefined>(
      clientUser.image,
    )

    useImperativeHandle(ref, () => ({ get: () => imageFileId || '' }), [
      imageFileId,
    ])

    return (
      <StyledBox>
        <WithEditableAvatar
          onSelectClick={() =>
            showProfilePictureMenu({
              onSubmit: setImageFileId,
              showDelete: !!imageFileId,
            })
          }
        >
          <StyledUserAvatar
            userId={clientUser.id}
            size={AvatarSize._3XL}
            overrideImage={imageFileId}
            openImageViewer
          />
        </WithEditableAvatar>
      </StyledBox>
    )
  },
)
